/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListPaymentMethodDto } from '../../models/api-response-list-payment-method-dto';

export interface GetAvailablePaymentMethods$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getAvailablePaymentMethods(http: HttpClient, rootUrl: string, params: GetAvailablePaymentMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPaymentMethodDto>> {
  const rb = new RequestBuilder(rootUrl, getAvailablePaymentMethods.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListPaymentMethodDto>;
    })
  );
}

getAvailablePaymentMethods.PATH = '/v1/api/payment-methods/list';
